<div class="d-none d-md-block delivery">
  <i
    [ngClass]="iconClass"
    class="delivery-i"
    role="img"
    [attr.aria-label]="deliveryText | translate"
    [attr.title]="deliveryText | translate"
  ></i>
</div>
<div class="d-block d-md-none">
  <div [ngClass]="textClass" class="delivery-text">
    <i
      [ngClass]="iconClass"
      class="delivery-i mobile-i"
      role="img"
      [attr.aria-label]="deliveryText | translate"
      [attr.title]="deliveryText | translate"
    ></i>
    {{ deliveryText | translate }}
  </div>
</div>
